import input_map from "~/maps/nyt-no-dc.json"
import input_data from "~/data/personal.csv"
/* CONFIG

Configure data used for graphic
*/

// DATA
export const INPUT_MAP = input_map
export const INPUT_DATA = input_data

// JOIN
// Connect INPUT_FILE_PATH and map data using the following keys
export const LEFT_JOIN_KEY = "key"
export const RIGHT_JOIN_KEY = "abbrv"
export const APPEND_KEY = "personal_policy"

// SCALE
// Set the color scale using this object property (will likely be the same property as APPEND_KEY)
export const SCALE_KEY = "personal_policy"


// LEGEND FORMATTER
// Optional: Replace legend values if desired
export const LEGEND_FORMAT = [
  {
    'label': 'prohibited',
    'replace': 'Banned',
  },
  {
    'label': 'conditional',
    'replace': 'Conditional',
  },
  {
    'label': 'no explicit ban',
    'replace': 'No explicit ban',
  }
]

// TOOLTIP FORMATTER
// Optional: Replace tooltip values if desired.
// Otherwise, use the same values as LEGEND_FORMAT or set as empty array.
export const TOOLTIP_FORMAT = [
  {
    'label': 'prohibited',
    'replace': 'Bans personal spending',
  },
  {
    'label': 'conditional',
    'replace': 'Has some restrictions',
  },
  {
    'label': 'no explicit ban',
    'replace': 'Has no explicit ban',
  }
];

// MAP SIZE
// Max and min number of pixels that map can expand to
export const MAP_MAX_WIDTH = 650
export const MAP_MIN_WIDTH = 300

// MAP TILE FONT SIZE
// Max is reached when viewport width is more than MID_BREAKPOINT.
// Min is reached when viewport is less than MAP_MIN_WIDTH
export const MIN_FONT_SIZE = 12
export const MAX_FONT_SIZE = 16

// BREAKPOINTS
// Change styles based on this screen size
export const MID_BREAKPOINT = 550